<template>
  <div class="privacy-attestation">
    <!-- 贝壳隐私合规团队 start -->
    <Problem-feedback></Problem-feedback>
    <!-- <Possessed-attestation></Possessed-attestation> -->
    <!-- 贝壳隐私合规团队 end -->
  </div>
</template>

<script>
// import PossessedAttestation from './PossessedAttestation'
import ProblemFeedback from "./ProblemFeedback";
export default {
  // 首页入口
  name: "privacyAttestation-index",
  components: { ProblemFeedback },
  mounted() {
    this.$store.dispatch("app/resetVuex");
  },
};
</script>
<style lang="scss" scoped>
.privacy-attestation {
  display: flex;
  justify-content: center;
}
</style>
